export default __webpack_public_path__ + "static/media/code-04.1a78b87a.svg";